webpackJsonp([32],{

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['licenseId'],
  data: function data() {
    return {
      err: '',
      success: '',
      activating: false
    };
  },
  methods: {
    activate: function activate() {
      var _this = this;

      this.activating = true;
      this.$http.post('license/activate/' + this.licenseId).then(function (res) {
        if (res.body.status === 'Success') {
          _this.success = 'License activated successfuly';
          setTimeout(function () {
            _this.success = '';
            _this.$emit('close');
            _this.activating = true;
          }, 3000);
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.activating = false;
        _this.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$lang.labels.licenseActivationText))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.no))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.activating
    },
    on: {
      "click": function($event) {
        return _vm.activate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.yes))])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.e8d49ef01a7675e3d20e.js